// import moment from 'moment';

export const initialColumns = [
	{
		title: 'File Name',
		id: 1,
		visible: true,
		// fixed: true,
		dataKey: 'name',
		width: '800',
	},
	{
		title: 'Description',
		id: 2,
		visible: true,
		dataKey: 'description',
		width: 'greedy',
	},
	{
		title: 'Created',
		id: 4,
		visible: true,
		dataKey: 'creationDate',
		width: 'greedy',
	},
];

export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_CURRENT_PAGE = 0;

export const DIALOG_TITLE_SINGLE_ROW = 'Delete location mapping?';

export const TOOLTIP_SINGLE_ROW = 'Delete location mapping';

export const TOOLTIP_MULTIPLE_ROWS = 'Delete location mappings';

export const DIALOG_CONTENT_SINGLE_ROW = `Do you want to delete the location mapping? Deleting a location mapping is permanent and can't be undone.`;

export const DIALOG_CONTENT_MULTIPLE_ROW = `Do you want to delete the selected location mappings? Deleting a location mapping is permanent and can't be undone.`;
